<div class="hitlist-container">
  <header class="hitlist-header">
    <h2 class="sr-only" i18n="sr-only@@marketplace.hitlist.title">Gefundene Personen</h2>

    <div class="header-info">
      @if (hasResults) {
        <span>
          <strong>{{ hitlist.totalMatches }}
            <ng-container i18n="@@marketplace.hitlist.goal">Treffer</ng-container>
          </strong>,
        </span>
        <div class="sort-selector">
          @if (sortFieldControl.value === ORDER_BY_SCORE) {
            <button (click)="toggleSort(ORDER_BY_DISTANCE)"
              class="link">
              <ng-container i18n="@@marketplace.hitlist.sortRelevanceScore">Sortiert nach Übereinstimmung
                        </ng-container>
              <span class="caret"></span>
            </button>
          }
          @if (sortFieldControl.value === ORDER_BY_DISTANCE) {
            <button (click)="toggleSort(ORDER_BY_SCORE)"
              class="link">
              <ng-container i18n="@@marketplace.hitlist.sortDistance">Sortiert nach Entfernung</ng-container>
              <span class="caret"></span>
            </button>
          }
        </div>
      }
      @if (!hasResults) {
        <strong i18n="@@marketplace.hitlist.noMatches">Keine Treffer</strong>
      }
    </div>
  </header>
  @if (!hasResults) {
    <app-no-results (saveQuery)="save()" [isSaving]="isSaving"
    [unsavedQuery]="unsavedQuery"></app-no-results>
  }

  @if (hasResults) {
    <ol class="hitlist">
      @for (result of hitlist.matches; track result; let i = $index) {
        <li class="item">
          <a [routerLink]="['/marketplace', result.member.id]" class="member-link">
            <article>
              <app-hitlist-item [match]="result"></app-hitlist-item>
            </article>
          </a>
        </li>
        @if ((i === 1) || (hitlist.totalMatches < 2 && i === hitlist.totalMatches - 1)) {
          <li class="item">
            <app-invitation></app-invitation>
          </li>
        }
      }
    </ol>
    <footer class="hitlist-footer">
      <button #loadMoreBtn (click)="loadMoreResults()"
        [disabled]="!hasMoreResults || (search.isMoreLoading$ | async)"
        class="button" i18n="@@marketplace.hitlist.loadMore">Mehr Treffer anzeigen
            </button>
    </footer>
  }
</div>
